'use client';

import React, { useState } from 'react';
import PessoaFisicaForm from './PessoaFisicaForm';
import PessoaJuridicaForm from './PessoaJuridicaForm';
import SuccessState from './SuccessState';

export type RegistrationType = 'pf' | 'pj';

export default function AdhesionFormContainer() {
  const [activeType, setActiveType] = useState<RegistrationType>('pf');
  const [isSuccess, setIsSuccess] = useState(false);
  const [submittedType, setSubmittedType] = useState<RegistrationType>('pf');

  const handleSuccess = (type: RegistrationType) => {
    setSubmittedType(type);
    setIsSuccess(true);
  };

  const handleReset = () => {
    setIsSuccess(false);
    setActiveType('pf');
  };

  if (isSuccess) {
    return <SuccessState type={submittedType} onReset={handleReset} />;
  }

  return (
    <div
      className="rounded-2xl card-shadow-lg overflow-hidden animate-slide-up"
      style={{ backgroundColor: 'var(--card)', border: '1px solid var(--border)' }}
    >
      {/* Type selector */}
      <div
        className="p-5 sm:p-6 border-b"
        style={{ borderColor: 'var(--border)', backgroundColor: 'rgba(0,0,0,0.3)' }}
      >
        <p
          className="text-xs mb-3 uppercase tracking-widest"
          style={{ color: 'var(--muted-foreground)', fontWeight: 600, letterSpacing: '0.08em' }}
        >
          Tipo de cadastro
        </p>
        <div
          className="flex rounded-xl p-1 gap-1"
          style={{ backgroundColor: '#000000', border: '1px solid var(--border)' }}
          role="tablist"
          aria-label="Tipo de cadastro"
        >
          {(
            [
              { value: 'pf', label: 'Pessoa Física', icon: '👤' },
              { value: 'pj', label: 'Pessoa Jurídica', icon: '🏢' },
            ] as const
          ).map((tab) => (
            <button
              key={`tab-${tab.value}`}
              role="tab"
              aria-selected={activeType === tab.value}
              onClick={() => setActiveType(tab.value)}
              className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-600 transition-all duration-200 ${
                activeType === tab.value ? 'tab-active' : 'tab-inactive'
              }`}
              style={{ fontWeight: 600 }}
            >
              <span>{tab.icon}</span>
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Form body */}
      <div className="p-5 sm:p-8">
        {activeType === 'pf' ? (
          <PessoaFisicaForm onSuccess={() => handleSuccess('pf')} />
        ) : (
          <PessoaJuridicaForm onSuccess={() => handleSuccess('pj')} />
        )}
      </div>
    </div>
  );
}